//Cart Timeout Related Events
export const SHOW_CART_TIMEOUT_WARNING = "cartTimeout:show_warning"
export const HIDE_CART_TIMEOUT_WARNING = "cartTimeout:hide_warning"
export const SHOW_CART_TIMEOUT_EXPIRED = "cartTimeout:expired"
